/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import Linkify from 'react-linkify';

import Localized from '../../../../shared/components/Localized';
import { StatusIcon } from '../../SVGIcon';
import { TIMESTAMP_FORMAT } from "../../../../shared/utils/dates";
import FooterTimeStamp from '../../FooterTimestamp';

import { Wrapper, TitleWrapper, Title, TimeStamp } from './styles.js';

const StatusIconWithMargin = styled(StatusIcon)`
  margin-right: 0.5rem;
`;

const Resolved = ({ feedItem, region, missingTranslations }) => (
  <Linkify properties={{ target: '_blank' }}>
    <Wrapper severity={feedItem.severity}>
      <TitleWrapper>
        <div>
          <StatusIconWithMargin
            severity={feedItem.severity}
            size='1.25rem'
          />
          <Title>
            <span>
              <Localized
                modelName='incidentResolved'
                modelKey='incidentResolvedTranslation'
                modelAttribute='incidentResolvedValue'
                missingTranslations={missingTranslations}
              />
            </span>
          </Title>
        </div>
        <TimeStamp severity={feedItem.severity}>
          { moment.tz(feedItem.dateTime, region).format(TIMESTAMP_FORMAT) }
        </TimeStamp>
      </TitleWrapper>
    </Wrapper>
  </Linkify>
);

export default Resolved;
